import { render, staticRenderFns } from "./auth-gr.vue?vue&type=template&id=014fe99b&scoped=true"
import script from "./auth-gr.vue?vue&type=script&lang=js"
export * from "./auth-gr.vue?vue&type=script&lang=js"
import style0 from "./auth-gr.vue?vue&type=style&index=0&id=014fe99b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014fe99b",
  null
  
)

export default component.exports